
import {httpservice} from '../services';
import {constants} from '../constant/constant';
import {CLIENT} from "../constant/actionTypes";

export default id => dispatch => {
    dispatch({
        payload: [],
        type: CLIENT.SOFTWARE_SUBMODULES.INITIATE
    });

    return httpservice()
        .get(`${constants.API.CLIENT_SOFTWARE_SUBMODULE}/${id}`)
        .then(response => {
            dispatch({
                payload: response.data.response,
                type: CLIENT.SOFTWARE_SUBMODULES.SUCCESS
            });
            return response.data.response;
        })
        .catch(function (error) {
            dispatch({
                payload: error,
                type: CLIENT.SOFTWARE_SUBMODULES.ERROR
            });
        });
};
